import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { FraudAwarenessBannerBottomSheetComponent } from './fraud-awarenned-banner-bottom-sheet/fraud-awareness-banner-bottom-sheet.component';
import { FraudAwarenessBannerService } from './fraud-awareness-banner.service';
import { FraudAwarenessBanner } from './fraud-awarenedd-banner.model';
import { utils } from 'protractor';
import { Util } from '../../../utils/util';

@Component({
  selector: 'app-fraud-awareness-banner',
  templateUrl: './fraud-awareness-banner.component.html',
  styleUrls: ['./fraud-awareness-banner.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class FraudAwarenessBannerComponent {

  showBanner = true;

  banner: FraudAwarenessBanner;

  constructor(public dialog: MatDialog, private bannerService: FraudAwarenessBannerService ) { }

  ngOnInit() {
    const bannerClosed = sessionStorage.getItem('bannerClosed');
    this.showBanner = bannerClosed !== 'true';
    this.banner = this.bannerService.getBanner();
  }

  openBottomSheet(){
      const dialogRef = this.dialog.open(FraudAwarenessBannerBottomSheetComponent, {        
        width: '375px',
        data: { banner: this.banner },
        panelClass: 'bottom-sheet-container',
        position: { right: '0', bottom: '0' }
      });
  }

  closeBanner() {
    this.showBanner = false;
    sessionStorage.setItem('bannerClosed', 'true');
  }

  get isMobile(){
    return Util.isMobile();
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/fraud-awareness-banner/fraud-awareness-banner.component.ts